import { usePostMutation } from "@/api/swr/useMutation";
import { companyStatusSchema } from "@/schema/console/companies/CompanyStatus";
import {z} from "zod";

type Config = Parameters<typeof usePostMutation<typeof companyStatusSchema, z.ZodNull>>[3]

export function useUpdateCompanyStatus(id: number,config: Config) {
  return usePostMutation(
    companyStatusSchema,
    z.null(),
    `/console/companies/${id}/update_status`,
    config
  )
}